/**
 * Configuração centralizada do URL da API
 * CORRIGIDO: Função dinâmica que SEMPRE retorna a origem correcta
 */

import axios from 'axios';

// Função DINÂMICA para obter o URL do backend
// NUNCA guardar em variável - chamar sempre a função
export const getBackendUrl = () => {
  // Em ambiente de browser, SEMPRE usar a origem actual
  if (typeof window !== 'undefined' && window.location && window.location.origin) {
    const origin = window.location.origin;
    
    // Em localhost, usar variável de ambiente para desenvolvimento
    if (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1') {
      const envUrl = process.env.REACT_APP_BACKEND_URL;
      // Só usar envUrl se for também localhost
      if (envUrl && (envUrl.includes('localhost') || envUrl.includes('127.0.0.1'))) {
        return envUrl;
      }
    }
    
    // Em QUALQUER outro caso (produção, preview, etc), usar a origem actual
    return origin;
  }
  
  // Fallback para SSR ou testes
  // Tentar usar variável de ambiente
  if (process.env.REACT_APP_BACKEND_URL) {
    return process.env.REACT_APP_BACKEND_URL;
  }
  
  return '';
};

// ==================== AXIOS COM RETRY AUTOMÁTICO ====================
const MAX_RETRIES = 5;
const RETRY_DELAY = 500;
const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

/**
 * Faz uma chamada axios com retry automático para erros de servidor
 * Usar em vez de axios.get/post/etc directamente
 */
export const apiCall = async (method, url, data = null, config = {}) => {
  const baseUrl = getBackendUrl();
  const fullUrl = url.startsWith('http') ? url : `${baseUrl}${url}`;
  
  const token = localStorage.getItem('token');
  const headers = {
    ...config.headers,
    ...(token ? { Authorization: `Bearer ${token}` } : {})
  };
  
  let lastError;
  for (let attempt = 0; attempt <= MAX_RETRIES; attempt++) {
    try {
      const response = await axios({
        method,
        url: fullUrl,
        data,
        headers,
        timeout: config.timeout || 30000,
        ...config
      });
      return response;
    } catch (error) {
      lastError = error;
      const status = error.response?.status;
      
      // Retry para erros 5xx ou erros de rede
      if ((status >= 500 || !error.response) && attempt < MAX_RETRIES) {
        console.log(`[API] Retry ${attempt + 1}/${MAX_RETRIES} para ${url}`);
        await sleep(RETRY_DELAY * (attempt + 1));
        continue;
      }
      throw error;
    }
  }
  throw lastError;
};

// Shortcuts para métodos comuns
export const apiGet = (url, config) => apiCall('get', url, null, config);
export const apiPost = (url, data, config) => apiCall('post', url, data, config);
export const apiPut = (url, data, config) => apiCall('put', url, data, config);
export const apiDelete = (url, config) => apiCall('delete', url, null, config);

// NOTA: NÃO exportar variáveis estáticas!
// Os componentes devem chamar getBackendUrl() directamente

// Para compatibilidade com código existente, exportar getters dinâmicos
export const API_BASE_URL = typeof window !== 'undefined' ? window.location.origin : '';
export const API_URL = API_BASE_URL + '/api';

export default {
  getBackendUrl,
  apiCall,
  apiGet,
  apiPost,
  apiPut,
  apiDelete
};
